"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreButton = _interopRequireDefault(require("@legacy-vfuk/core-button"));

var _coreHeading = _interopRequireDefault(require("@legacy-vfuk/core-heading"));

var _coreIcon = _interopRequireDefault(require("@legacy-vfuk/core-icon"));

var _coreParagraph = _interopRequireDefault(require("@legacy-vfuk/core-paragraph"));

var _coreBaseProps = require("@legacy-vfuk/core-base-props");

var Styled = _interopRequireWildcard(require("./styles/CardBody.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CardBody = function CardBody(_ref) {
  var primaryButton = _ref.primaryButton,
      secondaryButton = _ref.secondaryButton,
      heading = _ref.heading,
      chevron = _ref.chevron,
      paragraph = _ref.paragraph,
      _ref$centerButtons = _ref.centerButtons,
      centerButtons = _ref$centerButtons === void 0 ? false : _ref$centerButtons,
      id = _ref.id,
      dataSelectorPrefix = _ref.dataSelectorPrefix,
      dataAttributes = _ref.dataAttributes;
  var componentName = 'CardBody';
  return /*#__PURE__*/_react["default"].createElement(Styled.CardBody, _extends({
    id: id,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    "data-component-name": componentName
  }, dataAttributes), /*#__PURE__*/_react["default"].createElement(Styled.ContentWrapper, null, /*#__PURE__*/_react["default"].createElement(Styled.ContentWrapperHeader, {
    hasChevron: !!chevron
  }, chevron && /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], _extends({}, chevron, {
    name: "chevron-right",
    size: 3,
    group: "system",
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'chevron-right')
  })), /*#__PURE__*/_react["default"].createElement(_coreHeading["default"], _extends({}, heading, {
    weight: 1,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'heading')
  }))), paragraph && /*#__PURE__*/_react["default"].createElement(_coreParagraph["default"], {
    inverse: paragraph.inverse,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'paragraph')
  }, paragraph.text)), primaryButton && primaryButton.text && /*#__PURE__*/_react["default"].createElement(Styled.ButtonWrapper, {
    centerButtons: centerButtons
  }, /*#__PURE__*/_react["default"].createElement(_coreButton["default"], _extends({}, primaryButton, {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'primary-button')
  })), secondaryButton && secondaryButton.text && /*#__PURE__*/_react["default"].createElement(_coreButton["default"], _extends({}, secondaryButton, {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'secondary-button')
  }))));
};

CardBody.displayName = "CardBody";
var _default = CardBody;
exports["default"] = _default;
//# sourceMappingURL=CardBody.js.map